import type { ReactNode } from 'react';
import { Inbox } from 'lucide-react';
import { cn } from '../utils/cn.js';

export interface EmptyStateProps {
  title: string;
  hint?: ReactNode;
  icon?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ title, hint, icon, action, className }: EmptyStateProps) {
  return (
    <div className={cn('empty-state', className)}>
      <div className="empty-icon" aria-hidden>
        {icon ?? <Inbox size={28} />}
      </div>
      <h2 className="empty-title">{title}</h2>
      {hint ? <p className="empty-hint">{hint}</p> : null}
      {action ? <div className="empty-action">{action}</div> : null}
    </div>
  );
}
